import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { configurationProp, negativeBalanceProp } from 'src/app/interfaces/iresponse';
import { UserService } from 'src/app/services/apiCalls/userService/user.service';
import { BootstrapNotifyService } from 'src/app/services/bootstrap-notify/bootstrap-notify.service';


@Component({
  selector: 'app-configurations',
  templateUrl: './configurations.component.html',
  styleUrls: ['./configurations.component.css']
})
export class ConfigurationsComponent implements OnInit, OnDestroy {
  breadCrumb: any;
  loadingConfiguration:boolean = false;
  updating:boolean = false;
  sub!:Subscription;
  negativeBalance: Array<negativeBalanceProp> = [
    {id: 1, value: true}
  ]

  constructor(
    private userService:UserService, 
    private bootstrapNotifyService: BootstrapNotifyService) { }


  configurtionSettings = new FormGroup({
    allow_negative_balance: new FormControl(null, Validators.required),
    negative_balance_limit: new FormControl(null, [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]),
    sync_max_age: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$')]),
    sync_max_batch: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$')]),
    ops_near_limit_amount: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$')]),
  })


  ngOnInit() {

    this.getConfiguration();
    this.breadCrumb  = {
      name: 'Configuration',
      parent: 'Settings',
      subLink: null
    };
    

    this.sub = this.configurtionSettings.get('allow_negative_balance')?.valueChanges.subscribe((isValid: any)=>{
      const negativeLimit = this.configurtionSettings.get('negative_balance_limit');
      if(Boolean(isValid === 'true')){
        negativeLimit.enable()
      } else {
        negativeLimit.disable()
      }
      if(typeof isValid === 'boolean' &&  isValid === true){
        negativeLimit.enable();
      }
      this.configurtionSettings.updateValueAndValidity();
    })
  }

  getConfiguration(){
    this.loadingConfiguration = true;
    return this.userService.getConfigurationSettings().subscribe({
      next: (response)=>{
        const {allow_negative_balance, negative_balance_limit} = response.wallet_overdraft;
        const {sync_max_age, sync_max_batch, ops_near_limit_amount} = response.ticket;
        let currentLimit;
        if(!allow_negative_balance){
          currentLimit = {id: 2, value: false};
          const duplicate = this.negativeBalance.some((d)=> currentLimit.id === d.id);
          if(duplicate){
            return;
          }else{
            this.negativeBalance.push(currentLimit);
          }
        }else{
          currentLimit = {id: 2, value: false};
          const duplicate = this.negativeBalance.some((d)=> currentLimit.id === d.id);
          if(duplicate){
            return;
          }else{
            this.negativeBalance.push(currentLimit)
          }
        }
        this.configurtionSettings.patchValue(
          {allow_negative_balance, 
            negative_balance_limit: Number(negative_balance_limit),
            sync_max_age, sync_max_batch, ops_near_limit_amount: Number(ops_near_limit_amount)
          });
      },
      error: (err)=>{
        this.bootstrapNotifyService.error(err.error.message);
      }
    }).add(()=> this.loadingConfiguration = false)
  }

  submitConfiguration(){
    if(this.configurtionSettings.invalid){
      return;
    }
    const negativeBal =  this.configurtionSettings.get('allow_negative_balance')?.value;
    const negativeBalanceLimit =  this.configurtionSettings.get('negative_balance_limit')?.value;
    const maxAge =  this.configurtionSettings.get('sync_max_age')?.value;
    const maxBatch =  this.configurtionSettings.get('sync_max_batch')?.value;
    const limitAmount =  this.configurtionSettings.get('ops_near_limit_amount')?.value;
    this.updating = true;
    const payload = {
      wallet_overdraft:{
        allow_negative_balance: Boolean(negativeBal) === true ? false : true,
        negative_balance_limit: negativeBalanceLimit
      },
      ticket:{
        sync_max_age: maxAge,
        sync_max_batch: maxBatch,
        ops_near_limit_amount: limitAmount
      }
    } as configurationProp
    this.userService.postConfiguration(payload).subscribe({
      next:(response)=>{
        this.bootstrapNotifyService.success(response.message);
        this.getConfiguration();
      },
      error: (error)=>{
        const {message} = error.error;
        this.bootstrapNotifyService.error(message);
      }
    }).add(()=> this.updating = false)
  }

  ngOnDestroy(): void {
    if(this.sub) this.sub.unsubscribe();
  }

}
